<script setup>
import { onMounted, ref, defineProps } from 'vue';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '@/firebase';
import { utcToLocal } from '@/tools/TimeFunctions';

const props = defineProps({
  widget: {
    type: Object,
    required: true
  },
  dataID: {
    type: String,
    required: true
  },
  timeFormat: {
    type: String,
    default: '24hour'
  }
});

const tableData = ref(new Map([
  ['Time Stamp', []],
  ['Event', []]
]));

onMounted(() => {
  grabData();
});

const grabData = () => {
  onSnapshot(doc(db, 'data', props.dataID), (document) => {
    const docData = document.data();
    const timestamps = tableData.value.get('Time Stamp');
    const events = tableData.value.get('Event');

    const fmt = props.widget.timeFormat || props.timeFormat;
    timestamps.unshift(utcToLocal(docData.lastActivityUTC, fmt));
    events.unshift(docData.lastMessage);

    if (timestamps.length > 5) {
      timestamps.pop();
      events.pop();
    }

    tableData.value.set('Time Stamp', timestamps);
    tableData.value.set('Event', events);
  });
};
</script>

<template>
  <div class="bg-mc-cloud dark:bg-mc-charcoal border border-mc-steel dark:border-line-on-dark rounded-mc-sm overflow-hidden shadow-mc-sm">
    <div class="h-[3px] bg-mc-red shrink-0"></div>
    <div class="px-4 pt-3 pb-2 border-b border-mc-steel dark:border-line-on-dark">
      <h1 class="font-display font-extrabold text-[15px] leading-tight text-mc-ink dark:text-on-dark m-0">Event Log</h1>
    </div>
    <div class="overflow-x-auto">
      <table class="w-full border-collapse min-w-[300px]">
        <colgroup>
          <col class="w-[40%] sm:w-[30%]">
          <col class="w-[60%] sm:w-[70%]">
        </colgroup>
        <thead>
          <tr>
            <th
              v-for="column in tableData.keys()"
              :key="column"
              class="bg-mc-ink dark:bg-mc-charcoal px-3 py-2 text-left font-mono text-[10px] uppercase tracking-[0.1em] text-mc-white dark:text-on-dark"
            >
              {{ column }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="index in 5"
            :key="index"
            :class="index % 2 !== 0 ? 'bg-mc-cloud dark:bg-white/5' : 'bg-mc-white dark:bg-transparent'"
            class="h-8 sm:h-9"
          >
            <td
              v-for="value in tableData.values()"
              :key="value"
              class="px-3 py-2 text-left overflow-hidden text-ellipsis whitespace-nowrap text-sm text-mc-ink dark:text-on-dark"
            >
              {{ value[index - 1] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
